import TicketCreate from '_modules/ticket/views/TicketCreate.vue';
import TicketComments from '_modules/ticket/views/TicketComments.vue';
import TicketList from '_modules/ticket/views/TicketList.vue';
import Ticket from './Root.vue';


export default {
  path: 'chamados/',
  component: Ticket,
  name: 'admin-ticket',
  redirect: '/chamados/lista/1',
  children: [
    {
      path: 'lista/:page',
      name: 'admin-ticket-list',
      component: TicketList,
    },
    {
      path: 'novo',
      name: 'admin-ticket-new',
      component: TicketCreate,
    },
    {
      path: ':ticketId',
      name: 'admin-ticket-edit',
      component: TicketComments,
    },
  ],
};
